/* eslint-disable */
import Vue from 'vue';
import VeeValidate from 'vee-validate';
window.Vue = require('vue');
Vue.use(VeeValidate);
import Calculator from './components/Calculator.vue';

if (document.getElementById('app')) {
  const app = new Vue({
    el: '#app',
    components: {
      Calculator
    },
    render: h => h(Calculator)
  });
}




// WEBPACK FOOTER //
// ./scripts/calculator.js